// Number formats from the design handoff (ei-data.jsx): "$42.58M" style
// with trailing zeros stripped, "$420k" thousands, "1.70×" multipliers.
// The replots FormatType.CURRENCY formatter rounds differently, so the
// topline/decomposition/chips use these to match the design exactly.

export function fmtUSD(v: number): string {
  const a = Math.abs(v);
  if (a >= 1e12) return `$${(v / 1e12).toFixed(2).replace(/\.?0+$/, '')}T`;
  if (a >= 1e9) return `$${(v / 1e9).toFixed(2).replace(/\.?0+$/, '')}B`;
  if (a >= 1e6) return `$${(v / 1e6).toFixed(2).replace(/\.?0+$/, '')}M`;
  if (a >= 1e3) return `$${Math.round(v / 1e3)}k`;
  return `$${Math.round(v).toLocaleString()}`;
}

// Headcount with a compact suffix: "6M", "1.2M", "850K".
export function fmtCount(v: number): string {
  const a = Math.abs(v);
  if (a >= 1e6) return `${(v / 1e6).toFixed(1).replace(/\.0$/, '')}M`;
  if (a >= 1e3) return `${Math.round(v / 1e3)}K`;
  return `${Math.round(v).toLocaleString()}`;
}

export function fmtMult(v: number): string {
  return `${v.toFixed(2)}×`;
}
